import Create from './create';
import List from './list';
import Single from './single';
import SingleForwardingRule from './single-forwarding-rule';
import CreateForwardingRule from './create-forwarding-rule';

export default {
  Create,
  List,
  Single,
  SingleForwardingRule,
  CreateForwardingRule,
};
